/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core';

import { useMarkdownMultilineTranslate } from 'hooks/useTranslate/useTranslate';
import useTranslate from 'hooks/useTranslate';
import EmbeddedContinueButton from 'features/EmbeddedContinueButton';
import Button from 'components/Button';
import Link from 'components/Link';

import SimpleMessagePage from 'components/SimpleMessagePage';

interface PropTypes {
  canRetrieveDsp: boolean;
  accountIndex: string | undefined;
  cardType: string | undefined;
}

const DspExpiredView: React.FC<PropTypes> = props => {
  const { canRetrieveDsp, accountIndex, cardType } = props;

  const t = useTranslate();

  const tMdMultiline = useMarkdownMultilineTranslate();
  return (
    <SimpleMessagePage
      headerTitle="dspExpired.title"
      message={
        <React.Fragment>
          {canRetrieveDsp ? (
            <div>
              {tMdMultiline('dspExpired.retrievalSubtitle')}
              {tMdMultiline('dspExpired.retrievalMessage')}
            </div>
          ) : (
            <div>{tMdMultiline('dspExpired.expirationMessage')}</div>
          )}
        </React.Fragment>
      }
    >
      {canRetrieveDsp ? (
        <Button
          component={Link}
          to={{
            pathname: '/dsp-retrieval',
            state: { accountIndex, cardType },
          }}
          data-testid="retrieveDspButton"
          fullWidth
        >
          {t('dspExpired.retrieveButton')}
        </Button>
      ) : null}
      <EmbeddedContinueButton
        variant={canRetrieveDsp ? undefined : 'contained'}
      />
    </SimpleMessagePage>
  );
};

export default DspExpiredView;
